import {Validator} from "../validator.abstract";
import {ApplyMoment} from "./apply-moment.enum";

export class RequiredValidator extends Validator {

    public readonly applyMoment: ApplyMoment[] = [ApplyMoment.ON_INIT, ApplyMoment.ON_CHANGE];

    private readonly _message = `Dies ist eine Pflichtangabe.`;

    public isValid(value: any): string | null {
        return [null, undefined, ``, NaN].includes(value) ? this._message : null;
    }

}
